import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  CircularProgress,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const days = ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira'];

const fetchScheduleData = async () => {
  const subjects = [
    'Matemática',
    'Português',
    'Intervalo',
    'Geografia',
    'Ciências',
    'Física',
    'História',
    'Educação Física',
    'Artes',
    'Inglês',
    'Química',
    'Biologia',
    'Almoço'
  ];
  
  const times = [
    '07:30',
    '08:20',
    '09:10',
    '09:30',
    '10:20',
    '11:10',
    '12:00',
    '13:20',
    '14:10',
    '15:00',
    '15:20',
    '16:10'
  ];
  
  const classes = ['Turma 8º A', 'Turma 9º A', 'Turma 9º B', 'TURMA 1º A', 'TURMA 1º B', 'TURMA 1º C', 'TURMA 2º A', 'TURMA 2º B', 'TURMA 3º A', 'TURMA 3º B'];
  
  const mockData = {};
  
  classes.forEach(className => {
    mockData[className] = {
      'Segunda-feira': [],
      'Terça-feira': [],
      'Quarta-feira': [],
      'Quinta-feira': [],
      'Sexta-feira': []
    };
    
    // Horário específico para 8º A na Segunda-feira e Terça-feira
    if (className === 'Turma 8º A') {
      mockData[className]['Segunda-feira'] = [
        { time: '07:30', subject: 'Matemática' },
        { time: '08:20', subject: 'Português' },
        { time: '09:10', subject: 'Intervalo' },
        { time: '09:30', subject: 'Espanhol' },
        { time: '10:20', subject: 'Ciências' },
        { time: '11:10', subject: 'Geografia' },
        { time: '12:00', subject: 'Almoço' },
        { time: '13:20', subject: 'Eletiva' },
        { time: '14:10', subject: 'Eletiva' },
        { time: '15:00', subject: 'Intervalo' },
        { time: '15:20', subject: 'Práticas Integradoras' },
        { time: '16:10', subject: 'Práticas Integradoras' }
      ];
      
      mockData[className]['Terça-feira'] = [
        { time: '07:30', subject: 'Geografia' },
        { time: '08:20', subject: 'História' },
        { time: '09:10', subject: 'Intervalo' },
        { time: '09:30', subject: 'Português' },
        { time: '10:20', subject: 'Inglês' },
        { time: '11:10', subject: 'Inglês' },
        { time: '12:00', subject: 'Almoço' },
        { time: '13:20', subject: 'Artes' },
        { time: '14:10', subject: 'Educação Física' },
        { time: '15:00', subject: 'Intervalo' },
        { time: '15:20', subject: 'Projeto de Vida' },
        { time: '16:10', subject: 'Projeto de Vida' }
      ];
    }
    
    // Para os outros dias e turmas, manter o comportamento aleatório
    days.forEach(day => {
      if (className === 'Turma 8º A') {
        if (day === 'Quarta-feira') {
          mockData[className]['Quarta-feira'] = [
            { time: '07:30', subject: 'Arte' },
            { time: '08:20', subject: 'Português' },
            { time: '09:10', subject: 'Intervalo' },
            { time: '09:30', subject: 'Espanhol' },
            { time: '10:20', subject: 'Ciências' },
            { time: '11:10', subject: 'História' },
            { time: '12:00', subject: 'Almoço' },
            { time: '13:20', subject: 'Matemática' },
            { time: '14:10', subject: 'Matemática' },
            { time: '15:00', subject: 'Intervalo' },
            { time: '15:20', subject: 'Práticas Integradoras II' },
            { time: '16:10', subject: 'Práticas Integradoras II' }
          ];
          return;
        } else if (day === 'Quinta-feira') {
          mockData[className]['Quinta-feira'] = [
            { time: '07:30', subject: 'Geografia' },
            { time: '08:20', subject: 'Geografia' },
            { time: '09:10', subject: 'Intervalo' },
            { time: '09:30', subject: 'RAM' },
            { time: '10:20', subject: 'RAM' },
            { time: '11:10', subject: 'Educação Física' },
            { time: '12:00', subject: 'Almoço' },
            { time: '13:20', subject: 'Ciências' },
            { time: '14:10', subject: 'Ensino Religioso' },
            { time: '15:00', subject: 'Intervalo' },
            { time: '15:20', subject: 'História' },
            { time: '16:10', subject: 'História' }
          ];
          return;
        } else if (day === 'Sexta-feira') {
          mockData[className]['Sexta-feira'] = [
            { time: '07:30', subject: 'Português' },
            { time: '08:20', subject: 'Português' },
            { time: '09:10', subject: 'Intervalo' },
            { time: '09:30', subject: 'Ciências' },
            { time: '10:20', subject: 'Matemática' },
            { time: '11:10', subject: 'Matemática' },
            { time: '12:00', subject: 'Almoço' },
            { time: '13:20', subject: 'RALP' },
            { time: '14:10', subject: 'RALP' },
            { time: '15:00', subject: 'Intervalo' },
            { time: '15:20', subject: 'Ciências' },
            { time: '16:10', subject: 'Educação Física' }
          ];
          return;
        } else if (day === 'Segunda-feira' || day === 'Terça-feira') {
          return;
        }
      }
      
      mockData[className][day] = times.map((time) => {
        // Define fixed breaks
        if (time === '09:10') return { time, subject: 'Intervalo' };
        if (time === '12:00') return { time, subject: 'Almoço' };
        if (time === '15:10') return { time, subject: 'Intervalo' };
        
        // Filter out breaks from random subject selection
        const availableSubjects = subjects.filter(s => s !== 'Intervalo' && s !== 'Almoço');
        return {
          time,
          subject: availableSubjects[Math.floor(Math.random() * availableSubjects.length)]
        };
      });
    });
  });
  
  return mockData;
};

const fetchApiScheduleData = async () => {
  try {
    const response = await fetch('http://localhost:8000/api/disciplinas');
    if (!response.ok) {
      throw new Error('Failed to fetch schedule data');
    }
    const data = await response.json();
    console.log('API Response:', data);
    
    if (!data.results || data.results.length === 0) {
      console.log('No data received from API, falling back to mock data');
      return fetchScheduleData();
    }
    
    const formattedData = {};
    
    data.results.forEach(record => {
      const className = record.turma_nome || 'Turma não especificada';
      const day = record.dia_semana_display || 'Segunda-feira';
      const time = record.hora_inicio || '00:00';
      const subject = record.nome || 'Disciplina não especificada';
      
      if (!formattedData[className]) {
        formattedData[className] = {
          'Segunda-feira': [],
          'Terça-feira': [],
          'Quarta-feira': [],
          'Quinta-feira': [],
          'Sexta-feira': []
        };
      }
      
      formattedData[className][day].push({
        time: time,
        subject: subject
      });
    });
    
    Object.keys(formattedData).forEach(className => {
      Object.keys(formattedData[className]).forEach(day => {
        formattedData[className][day].sort((a, b) => a.time.localeCompare(b.time));
      });
    });
    
    return Object.keys(formattedData).length > 0 ? formattedData : fetchScheduleData();
  } catch (error) {
    console.error('Error fetching schedule data:', error);
    return fetchScheduleData();
  }
};

const Schedule = () => {
  const [selectedClass, setSelectedClass] = useState('');
  const [scheduleData, setScheduleData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const styles = {
    root: {
      py: 0.5,
      px: { xs: 0.5, sm: 1 },
    },
    title: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      mb: 0.5,
      textAlign: 'center',
      fontSize: { xs: '1.25rem', sm: '1.5rem' },
    },
    subtitle: {
      maxWidth: 600,
      mx: 'auto',
      mb: 2,
      textAlign: 'center',
      color: theme.palette.text.secondary,
      px: 1,
    },
    formContainer: {
      display: 'flex',
      justifyContent: 'center',
      mb: 1,
    },
    select: {
      minWidth: { xs: '90%', sm: 250 },
      '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        backgroundColor: theme.palette.background.paper,
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
    tableContainer: {
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
      borderRadius: '12px',
      width: '98%',
      height: 'auto',
      margin: '0 auto',
      '& .MuiTable-root': {
        borderCollapse: 'collapse',
        border: '1px solid black',
        width: '100%',
      },
    },
    headerCell: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontWeight: 'bold',
      padding: { xs: '3px 1px', sm: '4px' },
      textAlign: 'center',
      whiteSpace: 'nowrap',
      position: 'sticky',
      top: 0,
      zIndex: 1,
      border: '1px solid black',
      fontSize: { xs: '0.7rem', sm: '0.8rem' },
    },
    timeCell: {
      backgroundColor: theme.palette.grey[50],
      fontWeight: 'bold',
      width: { xs: '45px', sm: '60px' },
      position: 'sticky',
      left: 0,
      zIndex: 2,
      border: '1px solid black',
      fontSize: { xs: '0.7rem', sm: '0.8rem' },
    },
    cell: {
      padding: { xs: '2px 1px', sm: '3px' },
      textAlign: 'center',
      border: '1px solid black',
      whiteSpace: 'nowrap',
      minWidth: { xs: '65px', sm: '80px' },
      fontSize: { xs: '0.7rem', sm: '0.8rem' },
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '400px',
      gap: 2,
    },
  };

  useEffect(() => {
    const loadScheduleData = async () => {
      setLoading(true);
      try {
        const data = await fetchApiScheduleData();
        if (data && Object.keys(data).length > 0) {
          setScheduleData(data);
          setSelectedClass(Object.keys(data)[0]);
        }
      } catch (err) {
        setError('Erro ao carregar os horários. Por favor, tente novamente mais tarde.');
      }
      setLoading(false);
    };

    loadScheduleData();
  }, []);

  const handleClassChange = (event) => {
    setSelectedClass(event.target.value);
  };

  if (loading) {
    return (
      <Container>
        <Box sx={styles.loadingContainer}>
          <CircularProgress size={48} />
          <Typography variant="body1" color="text.secondary">
            Carregando horários...
          </Typography>
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Box sx={styles.loadingContainer}>
          <Typography variant="h6" color="error" textAlign="center">
            {error}
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={styles.root}>
      <Typography variant="h4" sx={styles.title}>
        Horário Escolar
      </Typography>
      <Typography variant="subtitle1" sx={styles.subtitle}>
        
      </Typography>
      
      <Box sx={styles.formContainer}>
        <FormControl sx={styles.select}>
          <InputLabel>Selecione a Turma</InputLabel>
          <Select
            value={selectedClass}
            label="Selecione a Turma"
            onChange={handleClassChange}
          >
            {Object.keys(scheduleData).map((className) => (
              <MenuItem key={className} value={className}>
                {className}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <TableContainer component={Paper} sx={styles.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...styles.headerCell, ...styles.timeCell }}>
                Horário
              </TableCell>
              {days.map((day) => (
                <TableCell key={day} sx={styles.headerCell}>
                  {isMobile ? day.slice(0, 3) : day}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedClass && scheduleData[selectedClass] &&
              Object.entries(scheduleData[selectedClass][days[0]]).map((slot, index) => (
                <TableRow 
                  key={slot[0]}
                  sx={{
                    '&:nth-of-type(odd)': {
                      backgroundColor: theme.palette.action.hover,
                    },
                    '&:hover': {
                      backgroundColor: theme.palette.action.selected,
                    },
                  }}
                >
                  <TableCell sx={styles.timeCell}>{slot[1].time}</TableCell>
                  {days.map((day) => {
                    const subject = scheduleData[selectedClass][day][index]?.subject;
                    const isBreak = subject === 'Intervalo' || subject === 'Almoço';
                    return (
                      <TableCell
                        key={`${day}-${slot[1].time}`}
                        sx={{
                          ...styles.cell,
                          backgroundColor: isBreak
                            ? `${theme.palette.primary.light}20`
                            : 'inherit',
                          color: isBreak
                            ? theme.palette.primary.dark
                            : 'inherit',
                          fontWeight: isBreak ? 'bold' : 'normal',
                        }}
                      >
                        {subject || '-'}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default Schedule;
